import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useEffect, useState } from 'react'

import { MOBILE_VIEW_BREAKPOINT } from '../../constants'
import useHomepage from '../../hooks/useHomepage'
import UtmContent from '../../models/UtmContent'
import { UrlService } from '../../services'

const HomepageTopBanner = () => {
  const { t } = useTranslation()
  const { activeCityName } = useHomepage()
  const [url, setUrl] = useState('')
  const isMobile = typeof window != 'undefined' && window.innerWidth < MOBILE_VIEW_BREAKPOINT

  useEffect(() => {
    const utmContent = new UtmContent({ position: 'homepage-top-banner' }).toString()
    setUrl(UrlService.signupUrl({ utmContent: utmContent, cityName: activeCityName }))
  }, [])

  return (
    <>
      {!isMobile && (
        <a href={url} style={{ textDecoration: 'none' }}>
          <div className="header-banner header-banner--fitness">
            {t('📅 Invitation: Private Sale! Lunch for ')}
            <span>{t('$3.48 ')}</span>
            {t(' >')}
          </div>
        </a>
      )}
      {isMobile && (
        <div className="header-banner header-banner--fitness">
          {t('📅 Invitation: Private Sale! Lunch for ')}
          <a href={url}>{t('$3.48 ')}</a>
          {t(' >')}
        </div>
      )}
    </>
  )
}

export default HomepageTopBanner
